/* Template showcase carousel: autoplay, click, swipe, keys; per-sector glow + badges; phone auto-scroll distance. */
(function () {
  function init(sec) {
    if (sec.__sc) return; sec.__sc = 1;
    var sc = sec.querySelector('.sc'), phones = [].slice.call(sec.querySelectorAll('.sc__phone'));
    var tabs = [].slice.call(sec.querySelectorAll('.sc__tab'));
    var badges = [].slice.call(sec.querySelectorAll('.sbadge'));
    var n = phones.length, active = 0, timer = 0, paused = false;
    var AUTO = +(sc.dataset.auto || 5000);
    if (!n) return;
    sc.style.setProperty('--auto', AUTO + 'ms');

    function go(i, user) {
      active = (i + n) % n;
      phones.forEach(function (p, k) {
        var pos = (k - active + n) % n;
        p.dataset.pos = pos === 0 ? 0 : pos === 1 ? 1 : 2;
        p.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
      });
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-selected', String(k === active));
        var bar = t.querySelector('i'); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      var p = phones[active];
      sec.style.setProperty('--g1', p.dataset.g1); sec.style.setProperty('--g2', p.dataset.g2);
      badges.forEach(function (b, bi) {
        setTimeout(function () {
          [].forEach.call(b.children, function (s, k) {
            var on = k === active;
            if (s.classList.contains('on') && !on) { s.classList.remove('on'); s.classList.add('was'); setTimeout(function () { s.classList.remove('was'); }, 700); }
            if (on) s.classList.add('on');
          });
        }, bi * 90);
      });
      restart();
    }
    function restart() { clearTimeout(timer); if (!paused) timer = setTimeout(function () { go(active + 1); }, AUTO); }
    function pause(v) { paused = v; sc.classList.toggle('is-paused', v); if (v) clearTimeout(timer); else restart(); }

    phones.forEach(function (p, k) { p.addEventListener('click', function () { if (k !== active) go(k, true); }); });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k, true); }); });
    sc.addEventListener('mouseenter', function () { pause(true); });
    sc.addEventListener('mouseleave', function () { pause(false); });
    sc.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(active + 1, true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(active - 1, true); e.preventDefault(); }
    });
    var stage = sec.querySelector('.sc__stage'), sx = null;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return; var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 40) go(active + (dx < 0 ? 1 : -1), true);
    });
    new IntersectionObserver(function (en) { if (!sc.matches(':hover')) pause(!en[0].isIntersecting); }, { threshold: .25 }).observe(sc);
    go(0);
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-why2]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
